
import axios from "axios";
import { provide, reactive, ref, toRefs, onMounted, onUnmounted } from "vue";
import store from "./store";
import { Moon, Sunny } from '@element-plus/icons-vue';
import BannerArtwork from "./components/BannerArtwork.vue";
import {
  FALLBACK_BANNER,
  fetchBannerManifest,
  selectDailySidebarBanner,
} from "./services/banner";
export default {
  components: { BannerArtwork },
  setup() {
    let bodyStyle = ref("");
    let mobileStatus = ref(false);
    let mobileDrawerStatus = ref(false);
    let isDarkMode = ref(false);
    const sidebarBanner = ref(FALLBACK_BANNER);

    let checkWidth = () => {
      let width = document.body.clientWidth;
      if (width > 1024) {
        mobileStatus.value = true;
        bodyStyle.value = "body-container";
      } else {
        mobileStatus.value = false;
        bodyStyle.value = "body-container-mobile";
      }
    };
    checkWidth();
    window.addEventListener("resize", checkWidth);
    let cookieName = ref(store.getters.getName);
    // 兜底判空：同时挡住空串、null，以及 localStorage 里可能被污染写入的
    // 字符串 "undefined" / "null"（脏值防御，避免左上角渲染出 "undefine" 之类）。
    if (
      cookieName.value == "" ||
      cookieName.value == null ||
      cookieName.value === "undefined" ||
      cookieName.value === "null"
    ) {
      cookieName.value = "获取饼干";
    }
    let updateCookieName = (name: string) => {
      cookieName.value = name;
    };
    provide("updateCookieName", updateCookieName);
    interface PlateItem {
      id: number;
      name: string;
    }

    let res = reactive({
      plateList: [] as PlateItem[],
    });
    let GetPlate = () => {
      axios.get("plate/get").then((response) => {
        res.plateList = response.data.data;
        store.commit("setPlate", res.plateList);
      });
    };
    GetPlate();
    const activeIndex = ref("1");

    const handleThemeChange = () => {
      const theme = isDarkMode.value ? 'dark' : 'light';
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem('theme', theme);

      const themeLink = document.getElementById('theme-css') as HTMLLinkElement;
      if (themeLink) {
        themeLink.href = `/css/${theme}-theme.css`;
      }
    };

    onMounted(() => {
      const savedTheme = localStorage.getItem('theme') || 'light';
      isDarkMode.value = savedTheme === 'dark';
      handleThemeChange();
      fetchBannerManifest()
        .then((manifest) => {
          sidebarBanner.value = selectDailySidebarBanner(manifest);
        })
        .catch(() => {
          sidebarBanner.value = FALLBACK_BANNER;
        });
    });

    onUnmounted(() => {
      window.removeEventListener("resize", checkWidth);
    });

    return {
      ...toRefs(res),
      activeIndex,
      cookieName,
      mobileStatus,
      mobileDrawerStatus,
      bodyStyle,
      isDarkMode,
      Moon,
      Sunny,
      handleThemeChange,
      sidebarBanner,
    };
  },
};
